<template>
    <div class="c-slider" ref="carousel">
        <ul class="c-slider__pagination u-mt-10">
            <li class="c-slider__pagination-item" v-for="(slide, i) in slides" :class="{'is-active' : (active === i)}">
                <a @click="goToSlide(i)" class="c-slider__pagination-link">{{ i + 1 }}</a>
            </li>
        </ul>
        <div class="c-slider__inner" :style="sliderStyle" ref="carouselInner">
            <slot></slot>
        </div>
        <section class="o-section">
            <div class="o-container--tablet" v-if="(active + 1) < slides.length">
                <div class="grid-tablet-push-4 grid-container-8 u-text-center tablet:u-text-left">
                    <a @click="navigate(+1)" title="Betrokkenen" class="c-pagination" v-if="nextTitle">
                    <span class="c-pagination__label">
                        <span class="c-pagination__sub-label">Volgende stap</span>
                            {{ nextTitle.title }}
                        </span>
                        <span class="c-pagination__icon"><i class="fas fa-arrow-alt-circle-right"></i>
                    </span>
                    </a>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import Hammer from 'hammerjs'

    export default {
        data() {
            return {
                touch: null,
                slides: [],
                active: 0,
                offsetMove: 0,
                sizes: {
                    carousel: 'auto',
                    slide: 0,
                }
            }
        },
        computed: {
            nextTitle(){
                if(this.active+1 === this.slides.length){
                    return {
                        title: this.slides[0].title,
                        slide: 0
                    }
                } else {
                    return {
                        title: this.slides.length ? this.slides[this.active +1].title : null,
                        slide: this.active + 1
                    }
                }
            },
            offset() {
                return -(this.sizes.slide * this.active) + this.offsetMove;
            },
            sliderStyle() {
                return {
                    width: this.sizes.carousel + 'px',
                    height: this.slides[this.active]? this.slides[this.active].$el.clientHeight+ 'px' : 'auto',
                    transform: 'translateX(' + this.offset + 'px)'
                }
            },
            slideStyle(){
                return {
                    width: this.sizes.slide + 'px',
                }
            }
        },
        created() {
            this.slides = this.$children;
        },
        methods: {
            navigate: function (direction = +1) {

                let activeNext = this.active + direction;

                if(activeNext === this.slides.length) {
                    activeNext = 0;
                } else if(activeNext < 0) {
                    activeNext = (this.slides.length - 1);
                }

                this.goToSlide(activeNext);
            },
            goToSlide: function(slide){
                this.slides.forEach(function (e) {
                    e.isActive = false
                });

                this.active = slide;
                this.slides[slide].entering = false;
                this.slides[slide].isActive = true;
            },
            initKeyPress: function(){
                document.addEventListener('keyup', (event) => {
                    let key = event.key || event.keyCode;
                    if(key === 'ArrowRight'){
                        this.navigate(+1);
                    } else if(key === 'ArrowLeft'){
                        this.navigate(-1);
                    }
                });
            },
            calcSizes(){
                this.sizes.carousel = this.$refs.carousel.offsetWidth * this.slides.length;
                this.sizes.slide = this.$refs.carousel.offsetWidth;

                this.slides.forEach((e) => {
                    e.size = this.sizes.slide
                });
            },
            initTouch(){
                this.touch = new Hammer(this.$refs.carousel);
                this.touch.on("panleft panright", (ev) => {
                    this.offsetMove = ev.deltaX;
                });
                this.touch.on("panend", (ev) => {
                    this.offsetMove = 0;
                    if(ev.deltaX > 100){
                        this.navigate(-1)
                    } else if(ev.deltaX < -100){
                        this.navigate(+1)
                    }

                });
            }
        },
        mounted(){
            this.slides[0].isActive = true;

            window.addEventListener( 'resize', (e) => {
                this.calcSizes();
            });

            this.initKeyPress();
            this.calcSizes();
            this.initTouch();
        }
    }
</script>